const inflcrErrorCodes = [
    'access_user_already_confirmed',
    'access_user_confirmation_code_is_expired',
    'access_user_not_confirmed',
    'access_user_deactivated',
    'access_unknown_error',
    'access_invalid_user',
    'access_invalid_sso_user',
    'access_user_has_no_profiles',
    'access_user_profile_context_required',
    'content_provider_error',
    'delete_failed',
    'gallery_cannot_be_both_public_and_publicly_tagged',
    'invalid_state_transition',
    'media_not_added',
    'provider_token_is_expired',
    'update_failed',
    'payment_gateway_resource_already_exists',
    'exchange_brand_cannot_create_new_bulletin',
    'existing_conflict',
    'exchange_bulletin_applicant_limit_reached',
    'default',
];
export { inflcrErrorCodes };
